import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getProdutosCategorias(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("produtosCategoria/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getProdutosCategoriasPorNivel(context, $codigoCategoriaSuperior) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("produtosCategoria/access/listarPorNivel", {CODIGO_PRODUTO_CATEGORIA_SUPERIOR: $codigoCategoriaSuperior}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },     
    getProdutosCategoriasTodasPorNivel() {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("produtosCategoria/access/listarTodasPorNivel").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },     
    getProdutosCategoriasBox(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("produtosCategoria/access/listaBox", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getProdutoCategoria(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("produtosCategoria/access/obter", {ID_PRODUTO_CATEGORIA: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getProdutoCategoriaSimples(context, id) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("produtosCategoria/access/obterSimples", {ID_PRODUTO_CATEGORIA: id}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    deleteProdutoCategoria(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("produtosCategoria/access/excluir", {ID_PRODUTO_CATEGORIA: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    postProdutoCategoria(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("produtosCategoria/access/salvar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
